@if (authenticated) {
  <forge-icon-button #popup="forgePopover" [forgePopover]="popupTemplate" (click)="popup.open()"
    [forgePopoverCloseOnBlur]="true" forgePopoverArrow="true" forgePopoverPlacement="bottom-end"
    tabindex="0" aria-label="Application launcher">
    <forge-tooltip placement="bottom">Apps</forge-tooltip>
    <forge-icon style="--forge-icon-color: var(--_app-bar-foreground);" name="apps"></forge-icon>
  </forge-icon-button>
}

<ng-template #popupTemplate>
  <div class="nine-box">
    @if (isLoaded) {
      <div fxLayout="column" fxLayoutAlign="space-between" [ngClass]="nineBoxClasses">
        @for (row of mainApps; track row) {
          <div fxLayout="row" fxLayoutAlign="start start" class="appLinkRow">
            @for (app of row; track app; let i = $index) {
              <application-link fxFlex="25%" [application]="app" [autoFocus]="i === 0">
              </application-link>
            }
          </div>
        }
        @if (showAll) {
          <div>
            @for (row of moreApps; track row) {
              <div fxLayout="row" fxLayoutAlign="start start" class="appLinkRow">
                @for (app of row; track app) {
                  <application-link fxFlex="25%" [application]="app">
                  </application-link>
                }
              </div>
            }
          </div>
        }
        @if (showMoreOption) {
          <div (click)="onShowMoreClick($event)" class="appShowOption"
            telemetry="Submission-More">
            <span>More</span>
          </div>
        }
      </div>
    } @else {
      <div fxLayout="row" fxLayoutAlign="space-around center" class="skeletons">
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <forge-skeleton avatar></forge-skeleton>
          <forge-skeleton text></forge-skeleton>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <forge-skeleton avatar></forge-skeleton>
          <forge-skeleton text></forge-skeleton>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <forge-skeleton avatar></forge-skeleton>
          <forge-skeleton text></forge-skeleton>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <forge-skeleton avatar></forge-skeleton>
          <forge-skeleton text></forge-skeleton>
        </div>
      </div>
    }
  </div>
</ng-template>

